import { Injectable, Component } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { SessionHandler } from './session-handler.service';
import { Observable } from 'rxjs';
import { MdDialog, MdDialogRef } from '@angular/material';
import { LoaderService } from '../../loader/loader.service';
import { dialogComponent } from '../../dialog/dialog.component';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../config';

@Injectable()
export class HttpService {
  public url = APPCONFIG.appUrl;
  public serviceDocUrl=APPCONFIG.SERVICEDOCURL;

  public dialogRef;
  public headers = new Headers({
    'Content-Type': 'application/json',
    apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y'
  });
  token;
  constructor(
    private http: Http,
    private router: Router,
    private LoaderService: LoaderService,
    private dialog: MdDialog,
    public sessionHandler: SessionHandler
  ) {
    this.token = this.sessionHandler.getItem('token');
  }

  getRequest(url): Observable<Response[]> {
    this.sessionHandler.saveItem(
      'timestamp',
      Math.round(new Date().getTime() / 1000.0)
    );
    this.token = this.sessionHandler.getItem('token');
    let headers = new Headers({
      'Content-Type': 'application/json',
      apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
      'access-token':this.token
    });
    let options = new RequestOptions({ headers: headers });

    this.showLoader();
    return this.http
      .get(this.url + '/' + url, options)
      .map((res: Response) => this.errorCheckFunction(res.json(), 'api'))
      .catch((error: any) =>
        // Observable.throw(this.handleError(error, 'api') || 'Server error')
        Observable.throw(this.handleError(error, 'api'))

        );
  }
  getRequestWithoutLoader(url): Observable<Response[]> {
    this.sessionHandler.saveItem(
      'timestamp',
      Math.round(new Date().getTime() / 1000.0)
    );
    this.token = this.sessionHandler.getItem('token');
    let headers = new Headers({
      'Content-Type': 'application/json',
      apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
      'access-token':this.token
    });
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(this.url + '/' + url, options)
      .map((res: Response) => this.errorCheckFunction(res.json(), 'api'))
      .catch((error: any) =>
        // Observable.throw(this.handleError(error, 'api') || 'Server error')
        Observable.throw(this.handleError(error, 'api'))

      );
  }

  postRequest(body: Object, api: string): Observable<Response[]> {
    this.sessionHandler.saveItem(
      'timestamp',
      Math.round(new Date().getTime() / 1000.0)
    );
    this.showLoader();
    let bodyString = JSON.stringify(body);
    this.token = this.sessionHandler.getItem('token');
    let headers = new Headers({
      'Content-Type': 'application/json',
      apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
      'access-token':this.token

    });
    let options = new RequestOptions({ headers: headers });

    //console.log('api:'+api);
    if (api.indexOf('saveReturnOrderWithSAP') >= 0 || api.indexOf('extractFile') >= 0) {
      this.url = this.url.replace('/_ah/api', '');
    }

    return this.http
      .post(this.url + '/' + api, body, options)
      .map((res: Response) => this.errorCheckFunction(res.json(), api))
      .catch((error: any) =>
        // Observable.throw(this.handleError(error.json(), api) || 'Server error')
        Observable.throw(this.handleError(error, 'api'))

      );
  }

  public checkSession() {
    let timestamp = localStorage.getItem('timestamp');
    let currentTimeStamp = Math.round(new Date().getTime() / 1000.0);
    let diff = Math.abs(
      Math.floor((currentTimeStamp - parseInt(timestamp)) / 3600)
    );
    // return true;
    let userData = this.sessionHandler.getItem("userDetails");
    console.log("User Data : "+userData);
    if (diff > 2) {
      return false;
    } else if(userData != null){
      return true;
    }
    else{
      return false;
    }
  }

  public showSessionError() {
    if(this.dialogRef == null){
      this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
      this.dialogRef.componentInstance.msg =
        'Session Expired.Please login again.';
    }
    // this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
    // this.dialogRef.componentInstance.msg =
    //   'Session Expired.Please login again.';
      
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        localStorage.clear();
				this.sessionHandler.clearAllItems();		
				this.sessionHandler.saveItem("defaultLanguage",'English');
        this.router.navigateByUrl('/login');
      }
      this.dialogRef = null;
    });
    this.onEnd();
  }
 



  public onEnd(): void {
    this.hideLoader();
  }

  public showLoader(): void {
    this.LoaderService.show();
  }
  public hideLoader(): void {
    this.LoaderService.hide();
  }

  public handleError(e: any, api) {
    let errorJson = e;
    if(errorJson.status==401){
      this.showSessionError();
      return false;
    }
    // this.dialogRef = this.dialog.open(dialogComponent, {
    //   disableClose: true
    // });
    this.hideLoader();
    return errorJson;
  }
  public handleErrorOld(e: any, api) {
    let errorJson = e;
    console.log(errorJson)
    if(errorJson.status==401){
      this.showSessionError();
      return false;
    }
    // console.log(errorJson.error.message)
    // console.log(APPCONFIG.esrpErrorTexts[errorJson.error.message])
    this.dialogRef = this.dialog.open(dialogComponent, {
      disableClose: true
    });

    if (errorJson.error && api != 'userOperationsApi/v1/login') {
      if (APPCONFIG.esrpErrorTexts[errorJson.error.message]) {
        this.dialogRef.componentInstance.msg = APPCONFIG.esrpErrorTexts[errorJson.error.message];

        // this.layoutService.popToast(
        //   APPCONFIG.esrpErrorTexts[errorJson.error.error.message],
        //   APPCONFIG.toastrType.error
        // );
      }
      else {
         this.dialogRef.componentInstance.msg = 'Something went wrong.';
        // this.dialogRef.componentInstance.msg = APPCONFIG.esrpErrorTexts[errorJson.error.message];

        // this.layoutService.popToast(
        //   "Login failed. Please try again.",
        //   APPCONFIG.toastrType.error
        // );
      }
      // this.dialogRef.componentInstance.msg = errorJson.error.errors[0].message;
    }
    if (errorJson.error && api == 'userOperationsApi/v1/login') {
      if (APPCONFIG.esrpErrorTexts[errorJson.error.message]) {
        this.dialogRef.componentInstance.msg = APPCONFIG.esrpErrorTexts[errorJson.error.message];
      }
      else {
         this.dialogRef.componentInstance.msg = 'Something went wrong.';
      }

      // this.dialogRef = this.dialog.open(dialogComponent);
      // this.dialogRef.componentInstance.msg = errorJson.error.message;
      // alert(errorJson.error.message);
    }
    this.hideLoader();
    return false;
  }
  //Dialog to capture error for authorization
  public errorCheckFunction(jsonResult, api) {
    return jsonResult;
    // if(jsonResult.status == 'Error') {
    //     this.dialogRef = this.dialog.open(responseDialog,{disableClose:true});
    //     this.dialogRef.componentInstance.msg = jsonResult.errorMessage;
    //     this.dialogRef.componentInstance.code = jsonResult.code;
    // } else {
    // 	return jsonResult;
    // }
    // if(jsonResult.response.error_code == '101' && api != 'login' ){
    //     this.dialogRef = this.dialog.open(responseDialog,{disableClose:true});
    //     this.dialogRef.componentInstance.msg = jsonResult.response.statusMessage;
    //     this.dialogRef.componentInstance.code = jsonResult.response.kind;
    // }
    // else{
    //     return jsonResult;
    // }
  }

  public getToken(): string {
    return this.sessionHandler.getItem('token');
  }
  

  temp_getRequestWithFullURl(url): Observable<Response[]> {
    this.sessionHandler.saveItem(
      'timestamp',
      Math.round(new Date().getTime() / 1000.0)
    );
    this.token = this.sessionHandler.getItem('token');
    let headers = new Headers({
      'Content-Type': 'application/json',
      apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
      'access-token':this.token
    });
    let options = new RequestOptions({ headers: headers });

    this.showLoader();
    return this.http
      .get(url, options)
      .map((res: Response) => this.errorCheckFunction(res.json(), 'api'))
      .catch((error: any) =>
        // Observable.throw(this.handleError(error, 'api') || 'Server error')
        Observable.throw(this.handleError(error, 'api'))

      );
  }

  downloadPostRequest(url,body: Object) : Observable<Response[]> {   
    this.showLoader();
         
    //let headers = new Headers({'Content-Type': 'application/json'});
     let headers = new Headers({'apitoken': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ'});
    return this.http.post(this.serviceDocUrl +"/"+url, body, {headers: headers})
        .map((res:Response) => this.apiSuccess(res.json(),url))
        .catch((error:any) => Observable.throw(this.apiError(error.json(),url)));
}

public apiSuccess(jsonResult, api) {                                      
  return jsonResult;
}
public apiError(jsonResult, api) {
  return jsonResult;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/http.service.ts